import Api from './api.service'

export default {
  deleteMedia (object) {
    return Api().post('media/' + object.id, object.body)
  },
  uploadFile(object){
    return Api().post('media',object, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    })
  }
}